<template>
  <div class="email-register">
    <div class="side-image">
      <v-img
        :src="backgroundImage"
        class="img-register"
      />
    </div>
    <div class="register-content">
      <div class="register-card">
        <h1>{{ $t('validateEmail.title') }}</h1>
        <p>{{ $t('validateEmail.subtitle') }}</p>
        <v-text-field
          v-model="token"
          :label="$t('validateEmail.tokenLabel')"
          height="50"
          background-color="field_register"
          class="input-token"
        />
        <v-btn
          color="primary"
          @click="validateToken"
        >
          {{ $t('validateEmail.validate') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import imgBottles from '@/assets/register/garrafas.png';

export default {
  name: 'ValidateEmail',
  data() {
    return {
      token: '',
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    backgroundImage() {
      return imgBottles;
    },
  },
  methods: {
    ...mapActions(['validateEmailToken']),
    validateToken() {
      this.validateEmailToken({ email_token: this.token });
    },
  },
  watch: {
    currentUser: {
      handler(newVal) {
        if (newVal.email) {
          this.$router.push({ name: 'register' });
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.email-register {
  display: flex;
  flex-direction: row;
  height: 100vh;

  .side-image {
    width: 40%;
    background-color: $step_register_campany;
    .img-register {
      height: 100%;
      width: 100%;
      object-fit: cover;
      filter: none;
    }
  }

  .register-content {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $register_background;
  }

  .register-card {
    background: $card_background;
    border-radius: 16px;
    box-shadow: 0 2px 8px $card_shadow;
    padding: 40px 32px;
    min-width: 340px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    h1 {
      font-size: 2rem;
      font-weight: bold;
      margin-bottom: 8px;
      text-align: center;
    }
    p {
      color: $subtitle_gray;
      margin-bottom: 16px;
      text-align: center;
    }
    .input-token {
      width: 100%;
      border-radius: 8px;
    }
  }
}
@media (max-width: 1100px) {
  .email-register {
    display: flex;
    justify-content: center;
    .side-image {
      display: none;
    }
    .register-content {
      width: 100%;
    }
  }
}
</style>
